import { styled } from '@material-ui/core';

const ImgArticle = ({ producto }) => {
  return (
    <Content>
        <div style={{ position:  'relative' }}>
            <Img
                src={producto.Imagen}
                height='80px'
                width='80px'
                alt='productos'
            />
        </div>
    </Content>
  )
}

const Content = styled('div')({
    minWidth: '80px',
    minHeight: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

const Img = styled('img')(({ width, height }) => ({
    maxWidth: width,
    maxHeight: height,
    objectFit: 'scale-down'
}));

export default ImgArticle
